import {
  EMPTY_ERROR, LOGOUT, SET_LOADING, GET_DOCTOR_SUCCESS, GET_DOCTOR_FAILURE, SAVE_DOCTOR
} from './types';

const initialState = {
  doctors: [],
  doctor: null,
  error: null,
  isLoading: false,
};

const doctorReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCTOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        doctors: action.payload,
        error: null,

      };
    case GET_DOCTOR_FAILURE:
      return {
        ...state,
        doctor: null,
        isLoading: false,
        error: action.payload.response.data.error,
      };
    case SAVE_DOCTOR:
      return {
        ...state,
        doctor: action.payload
      };
    case EMPTY_ERROR:
      return {
        ...state,
        error: null,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default doctorReducer;
